export default function Marquee({ children, duration = 60, className = "", testid, nonstop, paused }) {
  return (
    <div className={`${nonstop ? "" : "marquee-wrap"} overflow-x-clip ${className}`} data-noreveal data-testid={testid}>
      <div className="marquee" style={{ "--dur": `${duration}s`, animationPlayState: paused ? "paused" : undefined }}>
        <div className="flex shrink-0">{children}</div>
        <div className="flex shrink-0" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
